import { render, staticRenderFns } from "./PaperTable2.vue?vue&type=template&id=54f1b2ca"
import script from "./PaperTable2.vue?vue&type=script&lang=js"
export * from "./PaperTable2.vue?vue&type=script&lang=js"
import style0 from "./PaperTable2.vue?vue&type=style&index=0&id=54f1b2ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports